import { IUserResource } from "@sol/sdk";

export const getUserFullName = (user?: Pick<IUserResource, "name" | "surname">): string => {
    if (!user) {
        return "";
    }

    return [user.name, user.surname].filter(Boolean).join(" ");
};
